import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import {
    IClassDetails,
    ISlotDetails,
} from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import { getSelectedSessionDetailsFieldName } from "../../../../SessionDetailsFormGroup.utils";

export const useSetSelectedSingleSessionDetails = ({
    session,
}: {
    session: IClassDetails | ISlotDetails;
}) => {
    const { setValue } = useFormContext();
    const { listingUuid, listingType } = useCheckoutBasicDetailsContext();

    useEffect(() => {
        const fieldName = getSelectedSessionDetailsFieldName({
            listingUuid,
            listingType,
        });
        setValue(fieldName, [session.uuid]);
    }, [session.uuid]);
};
